module.exports = __webpack_public_path__ + "img/tt_wintergarten.04c81770.jpg";